import { marcaDoCurso } from '../lib/marca-do-curso.js';

/**
 * O desenho da marca do curso. A decisão mora em `lib/marca-do-curso.ts`.
 *
 * Reexportado daqui de propósito: a vitrine e a trilha importam a marca inteira
 * de um lugar só, e ninguém precisa lembrar que a cor vem de um módulo e a caixa
 * de outro. É a mesma marca nas duas telas — ver o cabeçalho longo do módulo.
 */
export { marcaDoCurso };
export type { MarcaDoCurso } from '../lib/marca-do-curso.js';

/**
 * O monograma dentro da caixa.
 *
 * `aria-hidden` porque é decoração: quem lê por áudio já recebe o título — no
 * `aria-label` do cartão da vitrine e no texto do cartão da etapa. Duas letras
 * soltas no meio do caminho seriam só ruído a mais para quem não vê a tela.
 *
 * A cor é `--texto`, e não `--destaque`, porque `--texto` sobre `--superficie` é
 * o único par que a área garante legível (C4). O destaque é livre — pode ser um
 * verde-limão que some sobre o cinza —, e a marca não pode depender de ele ser
 * escuro o bastante.
 */
export function Monograma({ iniciais, className = '' }: { iniciais: string; className?: string }) {
  return (
    <span
      aria-hidden
      className={`grid h-full w-full select-none place-items-center font-semibold tracking-[0.14em] ${className}`}
      style={{ color: 'var(--texto)' }}
    >
      {iniciais}
    </span>
  );
}
